module.exports = __webpack_public_path__ + "static/media/AI_Processing_Icon.b692fb0b.svg";